import styled from "styled-components";

import {
	COLOR_TEXT_PRIMARY_B2C,
	MOBILE_L_BP,
	FONT_WT_MEDIUM,
	FONT_WT_LIGHT,
} from "@website-builder/utilities-index";

export const Container = styled.div`
	display: flex;
`;

export const Title = styled.h3`
	margin: 0px;
	font-size: 20px;
	font-weight: ${FONT_WT_MEDIUM};
	line-height: 1.69;
	color: ${COLOR_TEXT_PRIMARY_B2C};

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		font-size: 18px;
	}
`;

export const Description = styled.div`
	font-size: 16px;
	font-weight: ${FONT_WT_LIGHT};
	line-height: 1.69;
	color: ${COLOR_TEXT_PRIMARY_B2C};
`;

export const Icon = styled.div`
	margin-right: 17px;
	margin-top: 10px;
	width: 30px;
	img {
		width: 100%;
	}
`;
